import { z } from 'zod';

export const StrategicInitiativeSchema = z.object({
    id: z.string().optional(),
    title: z.string().min(1),
    description: z.string().optional(),
    ownerId: z.string().optional(),
    progress: z.number().min(0).max(100).optional(),
    status: z.string().optional(),
    startDate: z.string().optional().or(z.date().optional()),
    endDate: z.string().optional().or(z.date().optional()),
    customFields: z.record(z.unknown()).optional(),
});

export const CreateStrategicInitiativeSchema = StrategicInitiativeSchema.omit({ id: true });
export const UpdateStrategicInitiativeSchema = StrategicInitiativeSchema;
export const StrategicInitiativeFormSchema = StrategicInitiativeSchema;
